import React, { useEffect, useState } from "react";
function Footer() {
  const [visible, setVisible] = useState(true);

  return (
    <footer
      className="left-0 right-0 border-t border-neutral-border bg-neutral-white transition-transform duration-300 ease-in-out md:fixed md:bottom-0"
      style={{ transform: visible ? "translateY(0)" : "translateY(100%)" }}
    >
      <div className="mx-auto max-w-7xl px-4 py-3 sm:px-6">
        <div className=" border-neutral-border text-center">
          <p className="text-xs text-neutral-textSecondary">
            © {new Date().getFullYear()} WealthGrow Fintax Services. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
